// extracted by mini-css-extract-plugin
module.exports = {"search-section":"style_search-section__3IbVd"};